<div *ngIf="!isRaymond" class="registration--section-5">
    <div class="registration--selectDomainHeading">
        <div class="registration--domain-info " tabindex="0">
            <div class="registration--bullet-point">
                {{ state.registrationPage.domainInfo.stepNumber }}
            </div>
            <div>
                <h2>{{ state.registrationPage.domainInfo.heading }} </h2>
                <div class="registration--domain-note desktop">{{ state.registrationPage.domainInfo.description }}  </div>
            </div>
        </div>
        <div class="registration--domain-note mobile">{{ state.registrationPage.domainInfo.description }}  </div>
        <div class="registration--domain-content">
            <div class="registration--domain-content-header">
                {{ state.registrationPage.domainInfo.subHeading }}
            </div>
            <div class="registration--domain-content-value">
               <b> {{userDomain}} </b>
            </div>
            <div class="registration--domain-content-checkbox">
                <mat-checkbox [disabled]="service.disableDomainClaim" tabindex="0" [checked]="claimDomain" (change)="claimDomain = !claimDomain">{{ state.registrationPage.domainInfo.labelPrefix }}  <b>"{{ userDomain }}"</b> {{ state.registrationPage.domainInfo.labelSuffix }} 
                </mat-checkbox>
                <div *ngIf="service.disableDomainClaim" class="domainClaimed">
                    {{ errorMessage }} <a [href]="contactUs.url" target="_blank"> {{contactUs.label}} </a>
                </div>
            </div>
        </div>
    </div>
</div>

<hr *ngIf="!isRaymond"/>

<div class="registration--section-6">
    <div class="registration--selectLocationHeading" *ngIf="!service.isUploadSuccess">
        <div class="registration--profile-info" tabindex="0">
            <div class="registration--bullet-point">
                {{ !isRaymond ? state.registrationPage.additionalLocation.stepNumber : state.registrationPage.accountType.stepNumber }}
            </div>
            <h2 [ngClass]="{ 'registration--mainheading': state.additionalLocationGrid.length === 0 }">{{ state.registrationPage.additionalLocation.heading1 }}</h2>
        </div>
        <div class="registration--headingOr" tabindex="0">{{ state.registrationPage.additionalLocation.headingOr }}</div>
        <div class="registration--uploadFile ">
            <button class="registration--uploadClass" (click)="uploadListLocation()"> <img [src]="isRaymond ? '../../../../../assets/Images/uploadLocationListRaymond.svg' : '../../../../../assets/uploadLocationList.svg'"
                    alt={{state.registrationPage.additionalLocation.heading2?.altText}}>{{ state.registrationPage.additionalLocation.heading2?.label }}
            </button>
        </div>
    </div>
    <div class="registration--selectLocationHeading registration--uploadsuccess-heading" *ngIf="service.isUploadSuccess">
        <div class="registration--profile-info" tabindex="0">
            <div class="registration--bullet-point">
                {{ !isRaymond ? state.registrationPage.additionalLocation.stepNumber : state.registrationPage.accountType.stepNumber }}
            </div>
            <h2>{{ state.registrationPage.additionalLocation.heading2?.label }}</h2>
        </div>
    </div>
    <div class="registration--post-upload-success" *ngIf="service.isUploadSuccess">
        <div class="registration--post-upload-text" tabindex="0">{{state.registrationPage.additionalLocation.uploadSuccessText}}</div>
        <div class="registration--post-upload-subtext" tabindex="0">{{state.registrationPage.additionalLocation.uploadSuccessSubtext}}</div>
    </div>
    <div class="registration--primary-location" tabindex="0"  *ngIf="!service.isUploadSuccess">
        <h3>{{ state.registrationPage.additionalLocation.primaryLocationHeading }}</h3>
        <ng-container *ngIf="service.isPrimaryLocationPresent ; else primaryLocationAbsent">
            <div class="registration--companyName">{{ state.additionalLocationList.primaryLocationInfo.companyName }}
            </div>
            <div>
                <div>{{ state.additionalLocationList.primaryLocationInfo.addressLine1 }}</div>
                <div *ngIf="state.additionalLocationList.primaryLocationInfo.addressLine2">{{ state.additionalLocationList.primaryLocationInfo.addressLine2 }}</div>
                <div>
                    {{ state.additionalLocationList.primaryLocationInfo.city }}, {{ state.additionalLocationList.primaryLocationInfo.state }}, {{ state.additionalLocationList.primaryLocationInfo.zipCode }}
                </div>
                <div>{{ state.additionalLocationList.primaryLocationInfo.country }} </div>
            </div>
        </ng-container>
        <ng-template #primaryLocationAbsent>
            <div>_</div>
        </ng-template>
    </div>

    <div class="ribbon" *ngIf="(partiallySelected() || allSelected) && selectedGridData.length > 0">
        <div class="ribbonDesktop">
            <div class="align-center">
                <div class="cancel-button">
                    <kng-button class="cancel-button" [state]="state.ribbonClearButton" (clicked)="cancelSelection()"></kng-button>
                </div>
                <div class="selected-count" tabindex="0">{{countOfSelectedRequests()}} &nbsp;items selected</div>
            </div>
        </div>
        <div class="ribbonMobile">
            <div class="aligntop">
                <div class="cancel-button">
                    <kng-button class="cancel-button" [state]="state.ribbonClearButton" (clicked)="cancelSelection()"></kng-button>
                </div>
            </div>
            <div>
                <div class="selected-count" tabindex="0">{{countOfSelectedRequests()}} &nbsp;items selected</div>
            </div>
        </div>
    </div>

    <div class="table-responsive-md tableDesktop" *ngIf="!service.isUploadSuccess">
        <table class="table w-100" aria-labelledby="table">
            <thead tabindex="0">
                <tr>
                    <th class="pad-left checkboxHeaderDesktop">
                        <span class="non-breaking-space">&#160;</span>
                        <mat-checkbox tabindex="0" [checked]="allSelected && service.checkAll" (change)="setAll($event.checked)" [indeterminate]="partiallySelected()" [disabled]="state.additionalLocationGrid.length === 0"></mat-checkbox>
                    </th>
                    <th class="tableheaderDesktop" *ngFor="let header of state.additionalLocationGridHeaderDesktop"
                        tabindex="0">
                        {{header}}
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="state.additionalLocationGrid && state.additionalLocationGrid.length > 0">
                <tr tabindex="0"
                    *ngFor="let row of state.additionalLocationGrid| paginate: { itemsPerPage: 50,currentPage: pageNumber,totalItems: (state.additionalLocationGrid)?.length }">
                    <td class="pad-left checkboxBodyDesktop">
                        <span class="non-breaking-space">&#160;</span>
                        <mat-checkbox tabindex="0" [(ngModel)]="row.checked"
                            (ngModelChange)="updateAllSelected()"></mat-checkbox>
                    </td>
                    <td class="tablebodyDesktop">
                        <div class="kng-table--user-name" tabindex="0">{{row.companyName}}</div>
                    </td>
                    <td class="tablebodyDesktop">
                        <div class="kng-table--user-name" tabindex="0">{{row.address}}</div>
                    </td>
                    <td class="tablebodyDesktop">
                        <div class="kng-table--user-name" tabindex="0">{{row.country}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="no-results" *ngIf=" state.additionalLocationGrid.length === 0" tabindex="0">
            <img class="no-results-icon" src="{{state?.additionalLocationError?.icon}}" alt="no results" />
            <div class="no-results-text">{{state?.additionalLocationError?.message}}</div>
            <div class="no-results-subtext">{{state?.additionalLocationError?.messageSubText}}</div>
        </div>
    </div>

    <div class="table-responsive-sm tableMobile" *ngIf="!service.isUploadSuccess" >
        <table class="table w-100" aria-labelledby="table">
            <thead tabindex="0">
                <tr>
                    <th class="pad-left checkboxHeaderMobile">
                        <span class="non-breaking-space">&#160;</span>
                        <mat-checkbox tabindex="0" [checked]="allSelected && service.checkAll" (change)="setAll($event.checked)" [indeterminate]="partiallySelected()" [disabled]="state.additionalLocationGrid.length === 0"></mat-checkbox>
                    </th>
                    <th class="tableheaderMobile" tabindex="0">
                        {{state.registrationPage.additionalLocation.selectLocationTableHeader.selectAll}}
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="state.additionalLocationGrid && state.additionalLocationGrid.length > 0">
                <tr tabindex="0"
                    *ngFor="let row of state.additionalLocationGrid| paginate: { itemsPerPage: 50,currentPage: pageNumber,totalItems: (state.additionalLocationGrid)?.length }">
                    <td class="pad-left checkboxBodyMobile">
                        <span class="non-breaking-space">&#160;</span>
                        <mat-checkbox tabindex="0" [(ngModel)]="row.checked" (ngModelChange)="updateAllSelected()"></mat-checkbox>
                    </td>
                    <td class="tablebodyMobile">
                        <div class="tableMobileItem" tabindex="0">
                            <div class="tableMobileItemHeader">{{state.registrationPage.additionalLocation.selectLocationTableHeader.companyName}}</div>
                            <div class="tableMobileItemBody">{{row.companyName}}</div>
                        </div>
                        <div class="tableMobileItem" tabindex="0">
                            <div class="tableMobileItemHeader">{{state.registrationPage.additionalLocation.selectLocationTableHeader.address}}</div>
                            <div class="tableMobileItemBody">{{row.address}}</div>
                        </div>
                        <div class="tableMobileItem" tabindex="0">
                            <div class="tableMobileItemHeader">{{state.registrationPage.additionalLocation.selectLocationTableHeader.country}}</div>
                            <div class="tableMobileItemBody">{{row.country}}</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="no-results" *ngIf=" state.additionalLocationGrid.length === 0" tabindex="0">
            <img class="no-results-icon" src="{{state?.additionalLocationError?.icon}}" alt="no results" />
            <div class="no-results-text">{{state?.additionalLocationError?.message}}</div>
            <div class="no-results-subtext">{{state?.additionalLocationError?.messageSubText}}</div>
        </div>
    </div>

    <div class="pagination-container" *ngIf="state.additionalLocationGrid.length !== 0  && !service.isUploadSuccess">
        <div class="show-data" tabindex="0">
            <span class="pagination-showing">Showing {{ pager.startIndex + 1 | number
                }}-{{(state.additionalLocationGrid).length > pager.pageSize * (pager.currentPage) ?
                pager.pageSize * (pager.currentPage): (state.additionalLocationGrid).length | number }} of {{
                (state.additionalLocationGrid)?.length | number }}</span>
        </div>
        <pagination-controls role="currentpage" (pageChange)="setPage($event)" previousLabel=""
            aria-controls="setPage($event)" nextLabel="" class="pagination-bar" [maxSize]="7" nextLabel="next"
            [autoHide]="true" screenReaderPaginationLabel="Pagination Navigation" previousLabel="previous"
            screenReaderCurrentLabel="You are on the current Page "></pagination-controls>
    </div>

    <div class="registration--button-container">
        <kng-button id="submitLocation" class="registrationButton"
            [state]="state.additionalLocationSubmitButton" (click)="submitAdditionalLocation()"></kng-button>
    </div>
</div>

<kng-modal-component #confirmSubmit *ngIf="!businessRegistrationFlowSubmitModalState.hidden"  (ctaClickedOn)="confirmRemovalModalEvent($event)"
[state]="businessRegistrationFlowSubmitModalState"></kng-modal-component>

<kng-modal-component class="content" #uploadModal *ngIf="!businessRegistrationUploadListModalState.hidden"  (ctaClickedOn)="confirmUserListModalEvent($event)"
[state]="businessRegistrationUploadListModalState"  (closed)="closeModalUpload()">
<div class="uploadList">
    <div class="sub-items">
        <div class="uploadSubHeading">{{state.uploadFileSection.subHeading}}</div>
            <ol class="list-items">
                <li class="content-block" *ngFor="let content of state.uploadFileSection.content">
                    <span class="label"> {{content.label}}: </span>
                    <span class="description"> {{content.description}} </span>
                </li>
            </ol>
    </div>
    <div class="downloadButton">
        <kng-button class="button-download" [state]="downloadButtonState"  (clicked)="downloadLocationTemplate()"  tabindex="-1">
        </kng-button>
      </div>
</div>
<div tabindex="-1" *ngIf="service.downloadTemplateError">
    <p class="downloadError">{{this.state.uploadFileSection.download.errorMessage}}</p>
</div>
<kng-upload-file #fileUploadComponent class="registerUploadList" (fileValidationCheck)="fileValidationCheck($event)" (tryAgainEventEmitter)="uploadFileServerValidation($event)"
(replaceFileEventEmitter)="replaceFileEventEmitter()" [state]="service.uploadFileState"></kng-upload-file>
</kng-modal-component>
